/* MAISON52 — recherche « IA » : le client décrit le produit en langage naturel (FR/EN,
   synonymes, couleurs, fautes légères, budget « moins de 80€ »). Sans app : index
   chargé depuis /collections/all/products.json à l'ouverture du popup de recherche. */

(function () {
  var idx = null, loading = null;
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  function prep(list) {
    list.forEach(function (p) {
      p._t = norm(p.t);
      p._ty = norm(p.ty);
      p._key = norm([p.t, p.ty, p.tg, p.o].join(' '));
      p._all = norm([p.t, p.ty, p.tg, p.o, p.d].join(' '));
    });
    return list;
  }
  function fetchIndex() {
    if (idx) return Promise.resolve(idx);
    if (loading) return loading;
    loading = fetch(ROOT + 'collections/all/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        idx = prep((data.products || []).map(function (p) {
          var v = p.variants || [];
          var price = v.length ? Math.min.apply(null, v.map(function (x) { return parseFloat(x.price); })) : 0;
          var tmp = document.createElement('div'); tmp.innerHTML = p.body_html || '';
          return {
            t: p.title, u: ROOT + 'products/' + p.handle,
            i: p.images && p.images[0] ? p.images[0].src + (p.images[0].src.indexOf('?') >= 0 ? '&' : '?') + 'width=400' : '',
            p: Math.round(price * 100), a: v.some(function (x) { return x.available; }),
            ty: p.product_type || '', tg: (p.tags || []).join(' '),
            o: (p.options || []).map(function (o) { return (o.values || []).join(' '); }).join(' '),
            d: (tmp.textContent || '').slice(0, 600)
          };
        }));
        return idx;
      })
      .catch(function () { loading = null; return []; });
    return loading;
  }
  function load() { return idx || []; }

  function norm(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[’']/g, ' ').replace(/[^a-z0-9€ ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  // Concepts : [libellé FR, libellé EN, mots déclencheurs, mots recherchés dans les produits, genre]
  var C = [
    ['Veste', 'Jacket', 'veste vestes blouson blousons manteau manteaux jacket jackets coat parka doudoune', 'jacket vest aborned firefighter crocodile embossed', 'type'],
    ['Gilet tactique', 'Tactical vest', 'gilet gilets tactique pare balles parballes bulletproof vest', 'bulletproof vest', 'type'],
    ['Jean', 'Jeans', 'jean jeans denim selvedge', 'jeans denim selvedge', 'type'],
    ['Hoodie / sweat', 'Hoodie', 'hoodie hoodies sweat sweats sweatshirt capuche pull pulls zip zippe zipper gilet', 'hoodie hood zip', 'type'],
    ['Survêtement', 'Tracksuit', 'survetement survet survets tracksuit tracksuits ensemble ensembles jogging track', 'hood zip jogger sweatpant tracksuit', 'type'],
    ['Pantalon / jogger', 'Pants', 'pantalon pantalons bas jogger joggers jogging joggings sweatpant sweatpants pants trousers', 'jogger sweatpant jeans pants', 'type'],
    ['Short / bermuda', 'Shorts', 'short shorts bermuda bermudas', 'short bermuda', 'type'],
    ['T-shirt', 'Tee', 'tshirt tshirts t shirt tee tees teeshirt haut hauts', 'tee', 'type'],
    ['Manches longues', 'Longsleeve', 'manches longues longsleeve longsleeves manche longue', 'longsleeve', 'type'],
    ['Chaussures', 'Footwear', 'chaussure chaussures basket baskets sneaker sneakers shoes shoe footwear kicks pompes paire paires', 'doubletongue footwear', 'type'],
    ['Accessoire', 'Accessory', 'accessoire accessoires bijou bijoux collier colliers chaine chaines necklace chain wallet cadeau gift', 'accessories necklace chain carabiner spinner', 'type'],
    ['Boxer', 'Boxers', 'boxer boxers calecon calecons slip sous vetement underwear', 'boxers', 'type'],
    ['Hand spinner', 'Hand spinner', 'spinner handspinner hand fidget', 'handspi52er spinner', 'type'],
    ['Noir', 'Black', 'noir noire noirs noires black', 'black', 'color'],
    ['Gris', 'Grey', 'gris grise grises grey gray', 'grey gray', 'color'],
    ['Rouge', 'Red', 'rouge rouges red bordeaux', 'red', 'color'],
    ['Vert', 'Green', 'vert verte verts vertes green kaki khaki olive', 'green', 'color'],
    ['Bleu / marine', 'Navy', 'bleu bleue bleus marine navy blue', 'navy blue', 'color'],
    ['Marron', 'Brown', 'marron brun brune brown camel', 'brown', 'color'],
    ['Blanc', 'White', 'blanc blanche white ecru creme', 'white snow', 'color'],
    ['Léopard', 'Cheetah', 'leopard guepard cheetah panthere animal', 'cheetah', 'color'],
    ['Camo', 'Camo', 'camo camouflage militaire army', 'camo', 'color'],
    ['Croco', 'Croc', 'croco crocodile', 'crocodile', 'color'],
    ['Clouté', 'Studded', 'clou clous cloute cloutee cloutes studded studs', 'studded', 'style'],
    ['Double capuche', 'Double hood', 'double capuche doublecapuche', 'double hood hooded', 'style'],
    ['Chaud / hiver', 'Warm / winter', 'hiver chaud chaude froid winter warm cold', 'jacket hoodie hood sweatpant jogger', 'vibe'],
    ['Été', 'Summer', 'ete summer leger legere chaleur', 'short bermuda tee', 'vibe']
  ];
  var TRIG = {};
  C.forEach(function (c, i) { c[2].split(' ').forEach(function (w) { TRIG[w] = i; }); });
  var STOP = ' un une des de du le la les l d pour avec sans et ou en au aux a je j cherche veux voudrais aimerais trouve trouver quelque chose truc style qui soit est ce cet cette mon ma mes me moi homme femme unisex the an for with and or i want need looking some something that is my of in to please stp svp tres bien beau belle joli jolie nouveau nouvelle ';

  function lev1(a, b) { // distance d'édition ≤ 1 ?
    if (Math.abs(a.length - b.length) > 1) return false;
    var i = 0, j = 0, e = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++e > 1) return false;
      if (a.length > b.length) i++; else if (b.length > a.length) j++; else { i++; j++; }
    }
    return e + (a.length - i) + (b.length - j) <= 1;
  }
  function trig(w) {
    if (TRIG[w] !== undefined) return TRIG[w];
    if (w.length > 3 && w[w.length - 1] === 's' && TRIG[w.slice(0, -1)] !== undefined) return TRIG[w.slice(0, -1)];
    if (w.length >= 5) for (var k in TRIG) if (k.length >= 5 && lev1(w, k)) return TRIG[k];
    return -1;
  }

  function parse(q) {
    var n = norm(q), max = null, min = null, m;
    if ((m = n.match(/(?:moins de|max|maximum|under|below|less than|<)\s*(\d+)/))) { max = +m[1]; n = n.replace(m[0], ' '); }
    if ((m = n.match(/(?:plus de|min|minimum|over|above|more than|>)\s*(\d+)/))) { min = +m[1]; n = n.replace(m[0], ' '); }
    if (/pas cher|petit prix|cheap|budget/.test(n)) { max = max || 60; n = n.replace(/pas cher|petit prix|cheap|budget/, ' '); }
    n = n.replace(/\d+\s*(€|eur|euros?|e)(?=\s|$)/g, ' ');
    var words = n.split(' ').filter(function (w) { return w && STOP.indexOf(' ' + w + ' ') < 0; });
    var concepts = [], free = [];
    words.forEach(function (w) {
      var ci = trig(w);
      if (ci >= 0) { if (concepts.indexOf(ci) < 0) concepts.push(ci); } else if (w.length >= 2) free.push(w);
    });
    return { concepts: concepts, free: free, max: max, min: min };
  }

  function has(text, terms) {
    return terms.split(' ').some(function (t) { return (' ' + text + ' ').indexOf(' ' + t) >= 0; });
  }

  var smartSearch = function (q) {
    var list = load(), P = parse(q);
    var colors = P.concepts.filter(function (i) { return C[i][4] === 'color'; });
    var types = P.concepts.filter(function (i) { return C[i][4] === 'type'; });
    var out = [];
    list.forEach(function (p) {
      var s = 0, miss = false;
      P.concepts.forEach(function (i) {
        var terms = C[i][3], kind = C[i][4];
        if (has(p._t, terms)) s += kind === 'vibe' ? 2 : 6;
        else if (has(p._ty, terms)) s += 4;
        else if (has(p._key, terms)) s += 3;
        else if (has(p._all, terms)) s += 1;
        else if (kind === 'color' || kind === 'type' || kind === 'style') miss = miss || { k: kind };
      });
      // une couleur demandée et absente, ou aucun type demandé trouvé → on écarte
      // (filtres sur titre / type / tags / options uniquement, pas la description)
      if (colors.length && !colors.some(function (i) { return has(p._key, C[i][3]); })) return;
      if (types.length && !types.some(function (i) { return has(p._key, C[i][3]); })) return;
      P.free.forEach(function (w) {
        if (p._t.indexOf(w) >= 0) s += 5;
        else if (p._all.indexOf(w) >= 0) s += 2;
        else if (w.length >= 5 && p._all.split(' ').some(function (x) { return x.length >= 5 && lev1(w, x); })) s += 1;
      });
      if (P.max !== null && p.p / 100 > P.max) return;
      if (P.min !== null && p.p / 100 < P.min) return;
      if (!P.concepts.length && !P.free.length && (P.max !== null || P.min !== null)) s = 1;
      if (s <= 0) return;
      if (p.a) s += 0.5;
      out.push({ p: p, s: s });
    });
    out.sort(function (a, b) { return b.s - a.s || (b.p.a - a.p.a); });
    var chips = P.concepts.map(function (i) { return FR ? C[i][0] : C[i][1]; });
    if (P.max !== null) chips.push((FR ? '≤ ' : 'under ') + P.max + ' €');
    if (P.min !== null) chips.push((FR ? '≥ ' : 'over ') + P.min + ' €');
    return {
      understood: chips,
      products: out.slice(0, 12).map(function (r) {
        return { title: r.p.t, url: r.p.u, image: { url: r.p.i }, price: r.p.p, available: r.p.a };
      })
    };
  };

  // ---------- Branchement sur le popup de recherche du header ----------
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return (c / 100).toLocaleString(FR ? 'fr-FR' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  var timer = null;

  function render(box, res, q) {
    var html = '<p class="m52-search__hint">' + esc((FR ? 'Compris : ' : 'Understood: ') + (res.understood.length ? res.understood.join(' · ') : q)) + '</p><div class="m52-search__list">';
    res.products.forEach(function (p) {
      html += '<a class="m52-search__item" href="' + esc(p.url) + '"' + (p.available ? '' : ' style="opacity:.55"') + '>' +
        '<img src="' + esc(p.image.url) + '" alt="" loading="lazy"><span>' + esc(p.title) + '</span><b>' + money(p.price) +
        (p.available ? '' : (FR ? ' · épuisé' : ' · sold out')) + '</b></a>';
    });
    html += '</div><a class="m52-search__seeall" href="' + ROOT + 'search?type=product&q=' + encodeURIComponent(q) + '">' + (FR ? 'Voir tous les résultats' : 'See all results') + '</a>';
    box.innerHTML = html;
  }

  function init() {
    var input = document.getElementById('m52SearchInput');
    var box = document.getElementById('m52SearchResults');
    if (!input || !box) return;
    input.placeholder = FR ? 'Décris ce que tu cherches : une veste noire pour l’hiver, des baskets léopard…' : 'Describe it: a black jacket for winter, cheetah sneakers…';
    input.addEventListener('focus', fetchIndex);
    // Écoute en phase de capture : si la recherche « IA » trouve, on affiche et on
    // bloque la recherche classique ; sinon on laisse la recherche Shopify prendre le relais.
    var reqId = 0;
    function empty(q) {
      box.innerHTML = '<p class="m52-search__empty">' + esc(FR ? 'Rien trouvé pour « ' + q + ' ». Essaie avec une couleur ou un type de pièce (veste, jean, baskets…).' : 'Nothing found for “' + q + '”. Try a colour or a type of piece (jacket, jeans, sneakers…).') + '</p>';
    }
    function run(q) {
      var my = ++reqId;
      var sp = document.getElementById('m52SearchSpinner');
      fetchIndex().then(function () {
        if (my !== reqId) return;
        var res = smartSearch(q);
        if (res.products.length) { if (sp) sp.style.display = 'none'; render(box, res, q); return; }
        // Repli : recherche Shopify classique (titres, descriptions, tags…)
        if (sp) sp.style.display = 'block';
        fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,body,tag,product_type,variants.title')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (my !== reqId) return;
            if (sp) sp.style.display = 'none';
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!ps.length) { empty(q); return; }
            render(box, { understood: [], products: ps.map(function (p) {
              return { title: p.title, url: p.url, image: { url: (p.image && p.image.url) || p.featured_image || '' }, price: Math.round(parseFloat(p.price) * 100), available: p.available !== false };
            }) }, q);
          })
          .catch(function () { if (sp) sp.style.display = 'none'; });
      });
    }
    // Phase de capture : notre recherche remplace entièrement l'ancienne recherche du header.
    document.addEventListener('input', function (e) {
      if (e.target !== input) return;
      e.stopImmediatePropagation();
      e.stopPropagation();
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        ++reqId;
        box.innerHTML = '<p class="m52-search__hint">' + (FR ? 'Décris ce que tu cherches : couleur, type de pièce, ambiance, budget…' : 'Describe what you’re after: colour, type of piece, vibe, budget…') + '</p>';
        return;
      }
      timer = setTimeout(function () { run(q); }, 200);
    }, true);
  }
  window.M52SmartSearch = function (q) { return smartSearch(q); };
  window.M52SmartSearch.load = fetchIndex;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
